import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex full-width" }
const _hoisted_2 = { class: "flex row items-center" }
const _hoisted_3 = { class: "text-body2" }
const _hoisted_4 = {
  key: 0,
  class: "text-weight-bold text-uppercase text-dark q-pl-xs",
  style: {"font-size":"10px","letter-spacing":"0.115em !important"}
}

import { computed } from "vue"
import { LoanStatusType_Enum } from "src/types/enums/index"


  
export default /*@__PURE__*/_defineComponent({
  __name: 'ApplicationProgress',
  props: {
    status: {
      type: Number as () => number | null,
      default: null
    }
  },
  setup(__props) {

const props = __props

  const label = computed(() => props.status ? LoanStatusType_Enum[props.status] : '')

  const stages = computed(() => {
    const ss = [
      {
        id: 0,
        label: "Quick quote",
        complete: isStageComplete(0),
        active: isStageActive(0)
      },
      {
        id: 1,
        label: "Underwriting",
        complete: isStageComplete(1) ? true : false,
        active: isStageActive(1)
      },
      {
        id: 2,
        label: "Manual review",
        complete: isStageComplete(2) ? true : false,
        active: isStageActive(2)
      },
      {
        id: 3,
        label: stageLabel(3),
        complete: isStageComplete(3) && !isNtu.value ? true : false,
        active: isStageActive(3)
      },
      {
        id: 4,
        label: "Awaiting Payout",
        complete: isStageComplete(4) && !isNtu.value ? true : false,
        active: isStageActive(4)
      },
      {
        id: 5,
        label: "Completed",
        complete: isStageComplete(5) && !isNtu.value ? true : false,
        active: isStageActive(5)
      },
    ] as { label: string, complete: boolean, active: boolean, id: number }[]
    return ss;
  })

  function isStageComplete(id: number) {
    switch (id) {
      case 0:
        return props.status !== null ? true : false
      case 1:
        return props.status !== null && props.status > LoanStatusType_Enum.Underwriting ? true : false;
      case 2:
        return props.status !== null &&props.status > LoanStatusType_Enum["Manual Review"] ? true : false;
      case 3:
        return props.status !== null &&props.status > LoanStatusType_Enum["Ready To Deal"] && props.status !== LoanStatusType_Enum["Unable To Contact"] ? true : false;
      case 4:
        return props.status !== null &&props.status > LoanStatusType_Enum["Awaiting Payout"] ? true : false;
      case 5:
        return props.status !== null && props.status === LoanStatusType_Enum.Completed ? true : false;
      default:
        return false;
    }
  }

  function isStageActive(id: number) {
    switch (id) {
      case 0:
        return props.status === null ? true : false
      case 1:
        return props.status === LoanStatusType_Enum.Underwriting ? true : false;
      case 2:
        return props.status === LoanStatusType_Enum["Manual Review"] ? true : false;
      case 3:
        return props.status === LoanStatusType_Enum["Ready To Deal"] || props.status === LoanStatusType_Enum["Unable To Contact"] || isNtu.value? true : false;
      case 4:
        return props.status === LoanStatusType_Enum["Awaiting Payout"] ? true : false;
      case 5:
        return props.status === LoanStatusType_Enum.Completed ? true : false;
      default:
        return false;
    }
  }

  function stageLabel(id: number) {
    switch (id) {
      case 3:
        return props.status === LoanStatusType_Enum["Ready To Deal"] ? "Ready to deal" :
          props.status === LoanStatusType_Enum["Unable To Contact"] ? "Unable to contact" :
            props.status === LoanStatusType_Enum.Underwriting ? "Ready to deal" :
              isNtu.value ? "Not taken up" : 'Ready to deal';
      default:
        return false;
    }
  }
  const isNtu = computed(() => {
    if(!props.status){
      return false;
    }
    return [
      LoanStatusType_Enum["NTU Lost To Competitor"],
      LoanStatusType_Enum["NTU No Contact"],
      LoanStatusType_Enum["NTU Other"],
      LoanStatusType_Enum["NTU Outside Criteria"],
      LoanStatusType_Enum["NTU Rate Too High"]
    ].includes(props.status)
  })

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stages.value, (state, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: state.label,
        class: ""
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_q_btn, {
            round: "",
            dense: "",
            size: "xs",
            color: state.complete ? 'positive' : state.active ? 'dark' : 'light-blue'
          }, {
            default: _withCtx(() => [
              (state.complete)
                ? (_openBlock(), _createBlock(_component_q_icon, {
                    key: 0,
                    name: "mdi-check"
                  }))
                : _createCommentVNode("", true),
              (!state.complete)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    style: {"letter-spacing":"0px !important","text-align":"center"},
                    class: _normalizeClass(["text-overline", !state.complete && !state.active ? 'text-dark' : ''])
                  }, _toDisplayString(index+1), 3))
                : _createCommentVNode("", true),
              _createVNode(_component_q_tooltip, null, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(state.label), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["color"]),
          (state.active)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(state.label), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_q_icon, {
            name: "mdi-minus",
            class: _normalizeClass(index < (stages.value.length -1) ? 'a' : 'hidden'),
            color: "light-blue"
          }, null, 8, ["class"])
        ])
      ]))
    }), 128))
  ]))
}
}

})